import { api } from "../App";
import { GET_EMK_LIST, GET_LIST_MODAL_TAB_EMK } from "./types";
import { createNotification } from "../components/Notifications/Notifications";

export const getListEMK = (params) => async (dispatch, getState) => {
  try {
    const urlParams = new URLSearchParams(params).toString();
    const { data } = await api.get(`/teaching_kit?${urlParams}`);
    dispatch({ type: GET_EMK_LIST, payload: data });
  } catch (error) {
    console.error('Error in educationalMethodologicalKits action:', error);
  }
};

export const createEMK = (data) => async (dispatch, getState) => {
  try {
    await api.post(`/teaching_kit`, data);
    await dispatch(getListEMK());
  } catch (error) {
    console.error('Error in educationalMethodologicalKits action:', error);
    createNotification('error', 'Ошибка')
  }
};

export const createCopyEMK = (id) => async (dispatch, getState) => {
  try {
    await api.post(`/teaching_kit/${id}/copy`);
    createNotification('success', 'Успешно');
  } catch (error) {
    console.error('Error in educationalMethodologicalKits action:', error);
    createNotification('error', error.message || 'Ошибка');
  } finally {
    await dispatch(getListEMK());
  }
};


export const updateEMK = (data) => async (dispatch, getState) => {
  try {
    await api.put(`/teaching_kit/${data.tkid}`, data);
    await dispatch(getListEMK());
  } catch (error) {
    console.error('Error in educationalMethodologicalKits action:', error);
  }
};

export const deleteEMK = (id) => async (dispatch, getState) => {
  try {
    await api.delete(`/teaching_kit/${id}`);
    createNotification('success', 'Успешно');
    await dispatch(getListEMK());
  } catch (error) {
    console.error('Error in educationalMethodologicalKits action:', error);
  }
};

//// список для таблицы в модалке
export const getListModalTabeEMK = (tkid) => async (dispatch, getState) => {
  try {
    const { data } = await api.get(`/teaching_kit/${tkid}/stuff`);
    dispatch({ type: GET_LIST_MODAL_TAB_EMK, payload: data });
  } catch (error) {
    console.error('Error in educationalMethodologicalKits action:', error);
  }
};